import ProductPage from './product-page';
export default ProductPage;